var React = require('react');

function PFFBrandIconsSocialSharingFacebook (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#9D9D9F;}\n"),React.createElement("path",{"id":"Facebook_1_","className":"st0","d":"M360,0C161.2,0,0,161.2,0,360c0,179.7,131.6,328.6,303.7,355.6V464.1h-91.4V360h91.4v-79.3\n\tc0-90.2,53.7-140.1,136-140.1c39.4,0,80.6,7,80.6,7v88.6h-45.4c-44.7,0-58.7,27.8-58.7,56.2V360h99.8l-16,104.1h-83.9v251.6\n\tC588.4,688.6,720,539.7,720,360C720,161.2,558.8,0,360,0z","key":1})]);
}

PFFBrandIconsSocialSharingFacebook.defaultProps = {"version":"1.1","id":"Icon","x":"0px","y":"0px","viewBox":"0 0 720 720","style":{"enableBackground":"new 0 0 720 720"},"xmlSpace":"preserve"};

module.exports = PFFBrandIconsSocialSharingFacebook;

PFFBrandIconsSocialSharingFacebook.default = PFFBrandIconsSocialSharingFacebook;
